import styled, { css } from 'styled-components';
import { PopoverSurface } from '@fluentui/react-components';
import {
  CheckmarkCircleRegular,
  MoreCircleRegular,
  DismissCircleRegular,
} from '@fluentui/react-icons';

const iconCommonStyles = css`
  width: 20px;
  height: 20px;
`;

export const ApprovedIcon = styled(CheckmarkCircleRegular)`
  ${iconCommonStyles};
  color: ${(props) => props.theme.successMessageColor};
`;

export const RejectedIcon = styled(DismissCircleRegular)`
  ${iconCommonStyles};
  color: ${(props) => props.theme.popupErrorColor};
`;

export const WaitingIcon = styled(MoreCircleRegular)`
  ${iconCommonStyles};
  color: ${(props) => props.theme.moreCircleIconColor};
`;

export const StyledPopOverSurface = styled(PopoverSurface)`
  padding: 5px 12px 7px 12px;
`;
